
export const SET_ANSWER = 'SET_ANSWER';
export const setAnswer = answer => {
  return {
    type: SET_ANSWER,
    data: answer,
  };
};

export const SET_QUESTION_ORDER = 'SET_QUESTION_ORDER';
export const setQuestionOrder = order => {
  return {
    type: SET_QUESTION_ORDER,
    data: order,
  };
};
